module.exports = __webpack_public_path__ + "static/img/19-0921_3.81ba912.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/newsDetail/images/19-0921_3.jpg
// module id = O8yd
// module chunks = 0